import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { queryClient } from '@/lib/queryClient'
import { SESSION_EXPIRED_EVENT } from '@timetable/api'

/**
 * Listens for the SESSION_EXPIRED_EVENT fired by the API layer when a token
 * refresh fails. Clears auth state and redirects to /login.
 *
 * Mount this once at the root layout level (PrivateLayout or App).
 */
export function useSessionExpiry() {
  const clearAuth = useAuthStore((state) => state.clearAuth)
  const navigate = useNavigate()

  useEffect(() => {
    const handleExpired = () => {
      clearAuth()
      queryClient.clear()
      navigate('/login', { state: { reason: 'session_expired' }, replace: true })
    }

    window.addEventListener(SESSION_EXPIRED_EVENT, handleExpired)
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handleExpired)
  }, [clearAuth, navigate])
}
